import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import { MessageService } from "primeng/api";

@Component({
  selector: "app-events",
  templateUrl: "./events.component.html",
  styleUrls: ["./events.component.css"],
})
export class EventsComponent implements OnInit {
  days: any;
  hours: any;
  minutes: any;
  seconds: any;
  typeList: any = [];
  typeFilter: any = "All";
  eventsData: any = []

  ResultData: any = []
  constructor(private router: Router,
    public global: GlobalService,
    private route: ActivatedRoute,
    private messageService: MessageService) {

    this.typeList = [
      { label: "All", value: "All" },
      { label: "International", value: "International" },
      { label: "National", value: "National" },
      { label: "Selection Trials", value: "Selection Trials" },

    ];

  }

  ngOnInit(): void {
    this.getEvents()

  }

  getTimer(date: any, id: any) {
    // Set the date we're counting down to
    var countDownDate = new Date(date).getTime();
    // Update the count down every 1 second
    var x = setInterval(function () {
      // Get today's date and time
      var now = new Date().getTime();

      // Find the distance between now and the count down date
      var distance = countDownDate - now;

      // Time calculations for days, hours, minutes and seconds
      this.days = Math.floor(distance / (1000 * 60 * 60 * 24));
      this.hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      this.minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((distance % (1000 * 60)) / 1000);
      document.getElementById(id).innerHTML =
        this.days +
        "d " +
        this.hours +
        "h " +
        this.minutes +
        "m " +
        this.seconds +
        "s ";
      console.log(this.days, this.hours, this.minutes, this.seconds);
    }, 1000);
  }

  generateResult() {
    this.eventsData = this.ResultData.filter((obj) => { return obj.type == this.typeFilter || this.typeFilter == "All" });

    for (let i = 0; i < this.eventsData.length; i++) {
      console.log("im time")
      this.getTimer(this.eventsData[i].dateTime, this.eventsData[i]._id)
    }
  }
  getEvents() {
    const url =
      this.global.basePath +
      "common/circularlist?modelType=event"
    this.global.GetRequestUnauthorised(url).subscribe((res: any) => {
      const data = res[0].json.circular;
      this.eventsData = data;
      this.ResultData = data;
      this.generateResult();




    });
  }
  filterByType(event: any) {
    //  this.name = event.value;
    this.generateResult();

  }
  newsDetails(id: any) {
    this.router.navigateByUrl("event-detail/" + id);
  }

  ClearFilters() {
    this.typeFilter = "All"

    // this.getDetails();
  }
}
